import React, { useState } from "react";
import { Lock } from "lucide-react";

export default function AdminLogin({ onSubmit, error, loading }) {
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password.trim()) onSubmit(password.trim());
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0e3a3f] via-[#1a5459] to-[#0e3a3f] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-[#e8a04d] mb-4">
            <Lock className="w-6 h-6 text-[#0e3a3f]" strokeWidth={2.2} />
          </div>
          <div className="text-xs tracking-[3px] uppercase text-[#e8a04d] font-semibold mb-2">
            Espace protégé
          </div>
          <h1 className="text-3xl font-serif text-white">Administration CFMPE</h1>
          <p className="text-white/60 mt-2 text-sm">Consultez toutes les demandes reçues</p>
        </div>
        <form
          onSubmit={handleSubmit}
          className="bg-white/5 backdrop-blur border border-white/10 rounded-2xl p-6 shadow-2xl"
          data-testid="admin-login-form"
        >
          <label className="block text-xs uppercase tracking-wider text-white/70 mb-2">
            Mot de passe
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/20 text-white placeholder-white/40 focus:outline-none focus:ring-2 focus:ring-[#e8a04d] focus:border-transparent"
            placeholder="••••••••"
            data-testid="admin-password-input"
          />
          {error && (
            <div className="mt-3 text-sm text-red-300" data-testid="admin-login-error">
              {error}
            </div>
          )}
          <button
            type="submit"
            disabled={loading}
            className="mt-5 w-full py-3 rounded-xl bg-[#e8a04d] hover:bg-[#d68e3b] text-[#0e3a3f] font-semibold transition-colors disabled:opacity-60"
            data-testid="admin-login-submit"
          >
            {loading ? "Connexion..." : "Se connecter"}
          </button>
        </form>
        <a
          href="/"
          className="block text-center text-white/50 hover:text-white/80 mt-6 text-sm transition-colors"
        >
          ← Retour au site
        </a>
      </div>
    </div>
  );
}
